import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { DataService } from '../../../data.service';
// import { Angulartics2 } from 'angulartics2';

@Component({
  selector: 'lc-product-preview',
  templateUrl: './product-preview.component.html',
  styleUrls: ['./product-preview.component.scss']
})
export class ProductPreviewComponent implements OnChanges {

  @Input('show') show_preview_popup: boolean;
  @Input('product') selected_product: any;
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output('process') processProduct: EventEmitter<any> = new EventEmitter();

  constructor(public dataService: DataService) { }

  ngOnChanges(changes) {
    if(!this.show_preview_popup) {
      this.close_popup();
    }
  }

  close_popup() {
    this.close.emit(true);
    this.show_preview_popup = false;
  }

  addItem(number){
    this.processProduct.emit({ action: 'add', product: this.selected_product });
    // this.angulartics2.eventTrack.next(
    //   { action: 'add_item_to_cart', properties: { category: 'add_item', label: this.selected_product.id }}
    // );
  }

  removeItem(number){
       this.processProduct.emit({ action: 'remove', product: this.selected_product });

        //  this.angulartics2.eventTrack.next(
        //   { action: 'remove_item_from_cart', properties: { category: 'remove_item', label: this.selected_product.id }}
        // );
  }

  _adjust_product_price(product){
    if(!!product.price_from_unit_count){
      for(let min_count in product.price_from_unit_count){
        let new_base = product.price_from_unit_count[min_count];
        if(!!new_base && product.order_amount >= min_count){
          product.base_price = new_base;
        }
      }
      if(product.base_price < product.price_from_unit_count['1']){
        product.orig_price = product.price_from_unit_count['1'];
      } else {
        product.orig_price = product.clean_orig_price;
      }
    }
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/product/product-preview/product-preview.component.ts